var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('fccTable',{attrs:{"responsive":"","striped":"","hover":"","fields":_vm.fields,"items":_vm.items}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"titlePage mb-3"},[_vm._v("Histórico de Importações por Requisições")])])])
}]

export { render, staticRenderFns }